import basicOperatorSymbolsJson from "./operator-symbols.json";
import supplementalOperatorSymbolsJson from "./supplemental-operator-symbols.json";
import symbolsJson from "./symbols.json";

export const greekLettersJson = symbolsJson.filter((s) => s.category === "Greek alphabet");
export const mathSymbolsJson = symbolsJson.filter((s) => s.category === "Mathematical symbols");
export const extLatinSymbolsJson = symbolsJson.filter((s) => s.category === "Extended latin");

export { default as functionsJson } from "./functions.json";
export { default as mathVariablesJson } from "./math-variables.json";
export { default as physicsVariablesJson } from "./physics-variables.json";
export { default as constantsJson } from "./constants.json";
export { default as groupsJson } from "./groups.json";
export { default as decoratorsJson } from "./decorators.json";
export { default as symbolsJson } from "./symbols.json";
export { default as fontConfigJson } from "./font-config-peano.json";
export { default as operatorsJson } from "./operators.json";
export { default as unitsJson } from "./units.json";
export { default as expressionsJson } from "./expressions.json";
export { default as switchNotationsJson } from "./switch-notations.json";

export const operatorSymbolsJson: typeof basicOperatorSymbolsJson = [
  ...basicOperatorSymbolsJson,
  ...supplementalOperatorSymbolsJson,
];

export * from "./types";
export * from "./schemas";
export * from "./keywords";
export * from "./nodeJson";
